import { useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import { Wrapper, AppBarR as PersistentDrawerRight } from '../components/common'
import { CreateDesk } from '../components/desk'
import db from '../db/db'
import { sessionState } from '../state'

const EditDesks = (_props: any) => {
  const [userState, setUserState] = useRecoilState(sessionState)

  const { id } = useParams()
  const deskEditor = () => {
    const deskToEdit = userState?.desks?.find(x => x.id === id)
    if (deskToEdit) {
      return (
        <CreateDesk
          user={userState.user}
          onCreate={() => {}}
          onUpdate={async (id: string) => {
            const dbDesk = await db.getById('desks', id)
            const newDeskList = userState.desks?.filter(x => x.id !== id)
            if (dbDesk) {
              newDeskList?.push(dbDesk)
            }
            setUserState(old => ({
              ...old,
              desks: newDeskList
            }))
          }}
          desk={deskToEdit}
        />
      )
    }
    return null
  }

  console.log('render')
  return (
    <>
      {/* <AppBar title='Our Office portal' actions={[]} /> */}
      <PersistentDrawerRight></PersistentDrawerRight>
      <Wrapper>{userState.user && deskEditor()}</Wrapper>
    </>
  )
}

export default EditDesks
